<template>
  <div class="warning-banner relative" v-if="isShowBanner">
    <span class="flex text-base-100 justify-center  items-center">
      <svg
        class="mr-2"
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.4974 0.666504C4.4474 0.666504 1.16406 3.94984 1.16406 7.99984C1.16406 12.0498 4.4474 15.3332 8.4974 15.3332C12.5474 15.3332 15.8307 12.0498 15.8307 7.99984C15.8307 3.94984 12.5474 0.666504 8.4974 0.666504ZM8.16406 3.99984C7.98725 3.99984 7.81768 4.07008 7.69266 4.1951C7.56763 4.32012 7.4974 4.48969 7.4974 4.6665C7.4974 4.84332 7.56763 5.01288 7.69266 5.13791C7.81768 5.26293 7.98725 5.33317 8.16406 5.33317H8.4974C8.67421 5.33317 8.84378 5.26293 8.9688 5.13791C9.09382 5.01288 9.16406 4.84332 9.16406 4.6665C9.16406 4.48969 9.09382 4.32012 8.9688 4.1951C8.84378 4.07008 8.67421 3.99984 8.4974 3.99984H8.16406ZM7.16406 6.6665C6.98725 6.6665 6.81768 6.73674 6.69266 6.86177C6.56763 6.98679 6.4974 7.15636 6.4974 7.33317C6.4974 7.50998 6.56763 7.67955 6.69266 7.80457C6.81768 7.9296 6.98725 7.99984 7.16406 7.99984H7.83073V9.99984H7.16406C6.98725 9.99984 6.81768 10.0701 6.69266 10.1951C6.56763 10.3201 6.4974 10.4897 6.4974 10.6665C6.4974 10.8433 6.56763 11.0129 6.69266 11.1379C6.81768 11.2629 6.98725 11.3332 7.16406 11.3332H9.83073C10.0075 11.3332 10.1771 11.2629 10.3021 11.1379C10.4272 11.0129 10.4974 10.8433 10.4974 10.6665C10.4974 10.4897 10.4272 10.3201 10.3021 10.1951C10.1771 10.0701 10.0075 9.99984 9.83073 9.99984H9.16406V7.33317C9.16406 7.15636 9.09382 6.98679 8.9688 6.86177C8.84378 6.73674 8.67421 6.6665 8.4974 6.6665H7.16406Z"
        />
      </svg>
      <span>

        {{ $i18nPresenter.t('plan_expiration',{
          plan : plan.name,
          dayPeriod : dayRemaining
        }) }}

      </span>
      <div class="font-bold underline ml-1 cursor-pointer" @click="actionReview">
        {{ $i18nPresenter.t('Review') }}
      </div>
    </span>
    <aha-icon
      @click="closeBanner"
      name="close"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      class="absolute right-5 cursor-pointer icon-close"
    />
  </div>
</template>
<script>

import { mapState } from 'vuex'
import moment from 'moment'
import utils from '@/util'
import eventCategories from '@/constant/eventCategories'

const DAY_BEFORE_EXPIRED = 7
export default {
  props: {
    isEditor: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isVisible: true,
    }
  },
  mounted() {
    const isVisibleBanner = localStorage.getItem('isVisibleBanner')
    if (isVisibleBanner && isVisibleBanner === 'false') {
      this.isVisible = false
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      plan: (state) => state.plan,
    }),

    isShowBanner() {
      const current_period_end = this.currentUser && this.currentUser.current_period_end
      const cancel_at_period_end = this.currentUser && this.currentUser.cancel_at_period_end
      if (!current_period_end || !this.isVisible || !cancel_at_period_end) return false
      if (moment(current_period_end).subtract(DAY_BEFORE_EXPIRED, 'days').isBefore(moment())) return true
      return false
    },
    dayRemaining() {
      const current_period_end = this.currentUser && this.currentUser.current_period_end
      if (!current_period_end) return 0
      return moment(current_period_end).diff(moment(), 'days')
    },
  },
  methods: {
    actionReview() {
      utils.mixpanelTracking(this.isEditor ? eventCategories.PRESENTATION_EDITOR
        : eventCategories.PRESENTATION_LIST, 'Plan Expiration Warning > Review')
      localStorage.setItem('isVisibleBanner', 'false')
      this.isVisible = false
      this.$router.push('/apps/user-plan')
    },
    closeBanner() {
      this.isVisible = false
      localStorage.setItem('isVisibleBanner', 'false')
      utils.mixpanelTracking(this.isEditor ? eventCategories.PRESENTATION_EDITOR
        : eventCategories.PRESENTATION_LIST, 'Plan Expiration Warning > Close')
    },
  },
}
</script>
<style lang="scss" scoped>
  .icon-close {
    cursor: pointer;
    color: black;
    font-size: 14px;
  }
  .warning-banner{
    border: 1px solid rgba(255, 202, 98, 0.20);
    background: #FFCD4B;
    text-align: center;
    padding: 12px;
    display: flex;
    justify-content: center;
    color: #fff;
    font-size: 14px;
    a{
      color: #313131;
    }

    @media (max-width: 559px) {
      padding: 8px;
      font-size: 10px;
    }

  }

</style>
